import dayjs from "dayjs";
import "dayjs/locale/nl"
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(localizedFormat);
dayjs.locale("nl");
